import {
  BRANCH_CATEGORY_TREE,
  BRANCH_MAIN_CATEGORIES,
  normaliseBranchCategories,
  orderBranchCategories,
  withoutBranchMainCategory,
  type BranchMainCategory,
  type ModuleCode,
} from '@his/shared';

type Licensed = (module: ModuleCode) => boolean;

export function mainCategoryOptions(chosen: readonly string[], licensed: Licensed): BranchMainCategory[] {
  return BRANCH_MAIN_CATEGORIES.filter((main) => licensed(main) || chosen.includes(main));
}

export function subCategoryOptions(main: BranchMainCategory, chosen: readonly string[], licensed: Licensed): string[] {
  return BRANCH_CATEGORY_TREE[main].filter((sub) => licensed(sub) || chosen.includes(sub));
}

export function toggleMainCategory(chosen: readonly string[], main: BranchMainCategory): string[] {
  return chosen.includes(main) ? withoutBranchMainCategory(chosen, main) : orderBranchCategories([...chosen, main]);
}

export function toggleSubCategory(chosen: readonly string[], sub: string): string[] {
  return orderBranchCategories(chosen.includes(sub) ? chosen.filter((code) => code !== sub) : [...chosen, sub]);
}

export function openingCategories(stored: readonly string[], licensed: Licensed): { categories: string[]; mainInferred: boolean } {
  const licensedSet = new Set(BRANCH_MAIN_CATEGORIES.filter((main) => licensed(main)));
  const categories = normaliseBranchCategories(stored, licensedSet);
  return { categories, mainInferred: categories.length !== new Set(stored).size };
}
